// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound__3h_J-","notfound404":"notfound_notfound404__oUzWn","notfound-404":"notfound_notfound-404__1CgpN"};